










































import { Component, Vue } from 'vue-property-decorator';
import jQuery from 'jquery';
import Loading from '@/components/Global/Loading.vue';
import Staff from '@/services/Staff';
@Component({
	name: 'SunlightPolicyDocsPage',
	components: {
		Loading,

	},
})
export default class SunlightQuotePage extends Vue {

    private policies: any;
    private loading: boolean = false;
    private async created() {

        this.loading = true;

        try {
			// Even though policies have likely already been fetched, thanks to
			// '@routing/GetPolicyInfo.ts', this forces a refresh for the most up-to-date
			// information.
			  this.policies = await this.getPolicies();
		} catch (error) {
			console.error(error);

		} finally {
			this.loading = false;
		}
        const iframe = jQuery('#policyDocsViewer');
        const url = "https://sunlight-dev.sunlightsolutions.com/ConstellationpreDev/webcustomerportal.aspx";
        const token = await this.getCurrentTokenId();
        const headers = [['Authorization',  token], ['Access-Control-Allow-Origin',  "*"]];
       // this.populateIframe(iframe, url, headers);
/*
        try{
             const response = await Staff.getSunlightQuotePage(token, url);
              iframe.attr('srcdoc', response);
        }catch(e){
             iframe.attr('srcdoc', '<html><head></head><body>Error loading page.</body></html>');
        } */
    }

    private async getPolicies() {
        const token = await this.getCurrentTokenId();
        const policies = await Staff.getSunlightPolicies('RV0001638', token);
        console.log('policies', policies);
        return policies.ListPolicies.Policies;

    }
     /* private populateIframe(iframe, url, headers) {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', url);
        xhr.onreadystatechange = handler;
        xhr.responseType = 'document';
        headers.forEach(function(header) {
            xhr.setRequestHeader(header[0], header[1]);
        });
        xhr.send();

        function handler() {
            if (this.readyState === this.DONE) {
                if (this.status === 200) {
                    const content = iframe[0].contentWindow ||
                        iframe[0].contentDocument.document ||
                        iframe[0].contentDocument;
                    content.document.open();
                    content.document.write(this.response.documentElement.innerHTML);
                    content.document.close();
                } else {
                    iframe.attr('srcdoc', '<html><head></head><body>Error loading page.</body></html>');
                }
            }
        }
    } */

    private async getCurrentTokenId() {
        const session = await this.$Amplify.Auth.currentSession();
        return session.idToken.jwtToken;

    }

}
